export enum CheckboxSize {
  Small = 'small',
  Large = 'large'
}
